import type { TrackingProperties } from '@change-corgi/tracking-properties';

import type { ShareAction } from '#src/app/shared/hooks/share';

import type { PetitionShareChannel } from '../../usePetitionShare';

export type ChannelEventProps = Readonly<{
	available_contexts: readonly string[];

	show_copylink: boolean;
	show_email: boolean;
	show_embed: false; // deprecated
	show_facebook: boolean;
	show_facebook_message: boolean;
	show_line: boolean;
	show_sms: boolean;
	show_twitter: boolean;
	show_vk: boolean;
	show_whatsapp: boolean;
}>;

const CHANNEL_MAP: Partial<Record<PetitionShareChannel, string>> = {
	facebookMessenger: 'facebook_message',
	copy: 'copylink',
};

export function shareActionsToEventProps(actions: readonly ShareAction[]): TrackingProperties {
	const channels: readonly string[] = actions.map(({ channel }) => CHANNEL_MAP[channel] || channel);
	return {
		available_contexts: channels,
		show_copylink: channels.includes('copylink'),
		show_email: channels.includes('email'),
		show_embed: false,
		show_facebook: channels.includes('facebook'),
		show_facebook_message: channels.includes('facebook_message'),
		show_line: channels.includes('line'),
		show_sms: channels.includes('sms'),
		show_twitter: channels.includes('twitter'),
		show_vk: channels.includes('vk'),
		show_whatsapp: channels.includes('whatsapp'),
	};
}
